import { hasOwnProperty } from '../../../helpers'
import { type AutocompleteOption } from '../model'

export const getOptionLabel = <Value = AutocompleteOption<string>>(option: Value): string =>
  String(hasOwnProperty(option, 'label') ? option.label : option)
